export default __webpack_public_path__ + "a85e99545e9c4c3030a9d97a17783e00.png";